// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Quick Grapple",
  id: "quick-grapple",
  metadata: {
    imports: ["grapple","aim","wait","self"],
    icon: {
      "backgroundColor": 3347537,
      "layers": [
        {
          "iconKey": "grapple",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -2,
          "color": 15297207
        },
        {
          "iconKey": "aim",
          "position": {
            "x": 16,
            "y": -2
          },
          "scale": 0.64,
          "rotation": 17,
          "color": 15528939
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -16,
            "y": -3
          },
          "scale": 0.58,
          "rotation": -13,
          "color": 16774655
        }
      ]
    },
  },
};

export default metadata;
